<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
export default {
    name: "App",
    mounted() {
        window.addEventListener("unload", this.saveState);
    },
    methods: {
        saveState() {
            localStorage.setItem("state", JSON.stringify(this.$store.state));
        },
    },
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
body {
    margin: 0px;
    padding: 0px;
    height: 100%;
    background-color: #f3f4f7;
}
html,
body,
#app {
    height: 100%;
}
::-webkit-scrollbar {
    display: none;
}
.el-dialog__header {
    padding: 0 !important;
}
.el-dialog__headerbtn {
    top: 10px !important;
    right: 10px !important;
}
.el-dialog__body {
    padding: 20px 20px 20px 20px !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4747ff !important;
}
/* 卡片头部高度 */
.el-card__header {
    padding: 5px 10px !important;
}
.el-card__body {
    padding: 5px 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue